import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const RHEA_AVATAR = "https://cdn.jotfor.ms/assets/agent-avatars/avatar_icon_79.png";
const COUPLE_IMG = "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/o9zd7w6y_8OhA8LIoIvTWX4h8aiJ8C%20%281%29.png";

export default function TalkToRheaPill() {
  return (
    <section data-testid="cta-after-problem" className="bg-background py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <Link
          to="/agents/rhea"
          data-testid="cta-after-problem-btn"
          className="group block rounded-2xl overflow-hidden border-2 border-primary/35 bg-foreground shadow-xl hover:border-primary hover:shadow-2xl hover:-translate-y-0.5 transition-all"
        >
          <div className="relative aspect-video overflow-hidden">
            <img src={COUPLE_IMG} alt="Talk to Rhea — Integrated Optimization Agent" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/75 via-foreground/20 to-foreground/30" />

            <div className="absolute top-4 left-4">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background/90 backdrop-blur-sm border border-border shadow-md">
                <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full rounded-full bg-accent opacity-75 animate-ping" /><span className="relative inline-flex rounded-full h-2 w-2 bg-accent" /></span>
                <span className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-foreground font-semibold">Live · AI Agent</span>
              </div>
            </div>

            <div className="absolute inset-0 grid place-items-center">
              <motion.div initial={{ scale: 0.95 }} whileInView={{ scale: 1 }} viewport={{ once: true }} className="h-16 w-16 md:h-20 md:w-20 rounded-full bg-background/95 backdrop-blur-sm grid place-items-center shadow-2xl ring-4 ring-foreground/30 group-hover:scale-110 transition-transform overflow-hidden">
                <img src={RHEA_AVATAR} alt="" data-testid="rhea-pill-avatar" className="h-full w-full object-cover" />
              </motion.div>
            </div>

            <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between gap-3">
              <div>
                <div className="font-mono text-[0.6rem] uppercase tracking-[0.22em] text-accent mb-1">Integrated Optimization Agent</div>
                <div className="font-display text-lg md:text-xl font-semibold leading-tight text-white">Ask Rhea — No Signup</div>
              </div>
              <span className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background/90 backdrop-blur-sm text-foreground text-xs font-semibold flex-shrink-0 group-hover:gap-2 transition-all">Start <span aria-hidden>→</span></span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}